import { getToken } from "../../helpers/get-token";
import axiosInstance from "../../axios/instance";

async function getAllInventoryCampaigns({ search, status, page, column_name, column_order }) {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;

        const params = {};
        if (search) {
            params.search = search;
        }
        if (status) {
            params.status = status;
        }
        if (page) {
            params.page = page;
        }
        if (column_name) {
            params.column_name = column_name;
        }
        if (column_order) {
            params.column_order = column_order;
        }

        const response = await axiosInstance.get(process.env.REACT_APP_HUB_URL + '/api/inventory-campaigns/all', {
            params
        });

        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getAllInventoryCampaigns;
